import { Carousel } from 'foundations-components/transitional/components/Carousel';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useCallback, useMemo } from 'react';
import { isFailed, isLoading, isSucceeded } from 'reporting-data/asyncData/AsyncData';
import PlatformReportResolver from 'reporting-ui-components/components/PlatformReport/PlatformReportResolver';
import useCloneTracker from '../../../../../../../hooks/useCloneTracker';
import useFetchRelationalReportsForKPIContent from './useFetchRelationalReportsForKPIContent';
import { useStandardizedReport } from 'reporting-ui-components/components/PlatformReport/useStandardizedReport';
import { jsx as _jsx } from "react/jsx-runtime";
const RelationalReportKPIContentBody = ({
  appUsageTracker,
  previewReport
}) => {
  const tracker = useCloneTracker(appUsageTracker);
  const snowflakeReportConfigsForCarouselFetch = useFetchRelationalReportsForKPIContent(previewReport);
  const reportsForCarousel = useMemo(() => {
    if (!isSucceeded(snowflakeReportConfigsForCarouselFetch)) {
      return [];
    }
    return snowflakeReportConfigsForCarouselFetch.data.map(report => ({
      // Alt can be left blank because we are not using images in the carousel
      alt: '',
      content: /*#__PURE__*/_jsx(PlatformReportResolver, {
        compact: true,
        useInlineLabels: false,
        report: report,
        trackingAssetType: "srv-summary-datawell",
        enableReportResolveUsageTracking: false
      })
    }));
  }, [snowflakeReportConfigsForCarouselFetch]);
  const onStepIndexChange = useCallback(({
    target: {
      value
    }
  }) => {
    tracker.track('srvDatawellCarouselIndexChange', {
      reportType: 'config',
      carouselIndex: value
    });
  }, [tracker]);
  if (isLoading(snowflakeReportConfigsForCarouselFetch)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered"
    });
  } else if (isFailed(snowflakeReportConfigsForCarouselFetch)) {
    throw new Error();
  } else {
    if (reportsForCarousel.length === 1) {
      return /*#__PURE__*/_jsx(PlatformReportResolver, {
        compact: true,
        useInlineLabels: false,
        report: snowflakeReportConfigsForCarouselFetch.data[0],
        trackingAssetType: "srv-summary-datawell",
        enableReportResolveUsageTracking: false
      });
    }
    return /*#__PURE__*/_jsx(Carousel, {
      maxWidth: "100%",
      steps: reportsForCarousel,
      onStepIndexChange: onStepIndexChange
    });
  }
};
const RelationalReportKPIContent = ({
  appUsageTracker,
  previewReport
}) => {
  /**
   * the useMeta hook does not handle the case when the report is not available yet. Because there is delay for
   * when we have to wait for the report to be standardized, the useMeta call is separated from the RelationalReportKPIContentBody
   * component.
   */
  const standardizedReportFetch = useStandardizedReport({
    report: previewReport,
    applyMigrateReport: true
  });
  if (isLoading(standardizedReportFetch)) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered"
    });
  } else if (isFailed(standardizedReportFetch)) {
    throw new Error(`Failed to standardize report and run report migration: ${standardizedReportFetch.error}`);
  }
  return /*#__PURE__*/_jsx(RelationalReportKPIContentBody, {
    appUsageTracker: appUsageTracker,
    previewReport: standardizedReportFetch.data
  });
};
export default RelationalReportKPIContent;